// import axios, {AxiosInstance} from "axios";

export abstract class BaseService {
    // protected static readonly connection = axios.create({baseURL: process.env.API_URL});

    // protected static createAdminConnection(): AxiosInstance
    // {
    //     return axios.create({ baseURL: process.env.API_URL, headers: { Authorization: `Bearer ${process.env.ADMIN_API_KEY}` }});
    // }

    public static async getData<T>(path: string, data?: any): Promise<T> {
        const uri = new URL(process.env.API_URL+path);
        if (data) {
            uri.search = this.createQueryString(data);
        }
        // console.log(uri.toString());
        const response = await fetch(uri.toString());
        if(!response.ok) {
            return [] as T;
        }
        const info = await response.json();
        return info;
    }

    public static createQueryString(data: any) {
        const reducer = (obj: any, parentPrefix = null) => (prev:any, key: any) => {
            const val = obj[key];
            key = encodeURIComponent(key);
            const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key;

            if (val == null || typeof val === 'function') {
                prev.push(`${prefix}=`);
                return prev;
            }

            if (['number', 'boolean', 'string'].includes(typeof val)) {
                prev.push(`${prefix}=${encodeURIComponent(val)}`);
                return prev;
            }

            prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'));
            return prev;
        };

        return Object.keys(data).reduce(reducer(data), []).join('&');
    }
}